"use strict";

var _interopRequireDefault = require("/root/workspace/mall_vue_JOYE/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
require("core-js/modules/es7.string.pad-start");
require("regenerator-runtime/runtime");
var _asyncToGenerator2 = _interopRequireDefault(require("/root/workspace/mall_vue_JOYE/node_modules/@babel/runtime-corejs2/helpers/asyncToGenerator.js"));
require("core-js/modules/es6.function.name");
var _booking_order = require("@/api/goods_activity/booking_order");
var _shopList = require("@/api/shop/shopList");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = exports.default = {
  name: 'BookingOrderTable',
  data: function data() {
    return {
      searchForm: {
        phone: '',
        orderNo: '',
        name: '',
        orderStatus: null,
        shopId: null,
        goodsTitle: ''
      },
      tableData: [],
      loading: false,
      pagination: {
        currentPage: 1,
        pageSize: 10,
        total: 0
      },
      shopList: [] // 门店列表
    };
  },
  created: function created() {
    this.fetchShopList();
    this.fetchData();
  },
  methods: {
    fetchShopList: function fetchShopList() {
      var _this = this;
      // 获取门店列表
      (0, _shopList.getStoreData)().then(function (response) {
        _this.shopList = response.records || [];
      }).catch(function (error) {
        console.error('获取门店列表失败:', error);
      });
    },
    fetchData: function fetchData() {
      var _this2 = this;
      this.loading = true;
      var params = {
        page: this.pagination.currentPage,
        limit: this.pagination.pageSize,
        bookingPhoneNum: this.searchForm.phone,
        orderSn: this.searchForm.orderNo,
        // 使用订单编号而不是订单ID
        bookingName: this.searchForm.name,
        orderStatus: this.searchForm.orderStatus,
        shopId: this.searchForm.shopId,
        goodsTitle: this.searchForm.goodsTitle
      };
      (0, _booking_order.bookingOrderPage)(params).then(function (response) {
        _this2.tableData = response.records || [];
        _this2.pagination.total = response.total || 0;
      }).catch(function (error) {
        console.error('获取数据失败:', error);
        _this2.$message.error('获取数据失败');
      }).finally(function () {
        _this2.loading = false;
      });
    },
    handleSearch: function handleSearch() {
      // 搜索逻辑
      console.log('搜索条件:', this.searchForm);
      this.pagination.currentPage = 1;
      this.fetchData();
    },
    handleDownload: function () {
      var _handleDownload = (0, _asyncToGenerator2.default)(/*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        var params, _t;
        return regeneratorRuntime.wrap(function (_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              _context.prev = 0;
              params = {
                bookingPhoneNum: this.searchForm.phone,
                orderSn: this.searchForm.orderNo,
                // 使用订单编号而不是订单ID
                bookingName: this.searchForm.name,
                orderStatus: this.searchForm.orderStatus,
                shopId: this.searchForm.shopId,
                goodsTitle: this.searchForm.goodsTitle
              }; // 调用导出API
              _context.next = 1;
              return (0, _booking_order.exportBookingOrderInfo)(params);
            case 1:
              this.$message.success('导出任务已启动，请稍后查看文件');
              _context.next = 3;
              break;
            case 2:
              _context.prev = 2;
              _t = _context["catch"](0);
              console.error('导出失败:', _t);
              this.$message.error('导出失败');
            case 3:
            case "end":
              return _context.stop();
          }
        }, _callee, this, [[0, 2]]);
      }));
      function handleDownload() {
        return _handleDownload.apply(this, arguments);
      }
      return handleDownload;
    }(),
    handleSizeChange: function handleSizeChange(size) {
      this.pagination.pageSize = size;
      this.fetchData();
    },
    handleCurrentChange: function handleCurrentChange(page) {
      this.pagination.currentPage = page;
      this.fetchData();
    },
    writeOff: function writeOff(row) {
      var _this3 = this;
      this.$confirm("\u786E\u8BA4\u6838\u9500\u8BA2\u5355 ".concat(row.orderSn, " \u5417\uFF1F"), '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(function () {
        var writeOffData = {
          orderId: row.orderId,
          auditCode: row.auditCode,
          userId: _this3.$store.getters.userId || 1 // 使用当前用户ID，如果获取不到则默认为1
        };
        (0, _booking_order.writeOffBookingOrder)(writeOffData).then(function (response) {
          _this3.$message.success(response.message || '核销成功');
          // 重新获取数据以更新状态
          _this3.fetchData();
        }).catch(function (error) {
          console.error('核销失败:', error);
          _this3.$message.error(error.message || '核销失败');
        });
      }).catch(function (error) {
        // 用户取消核销，仅在用户主动取消时显示提示
        if (error === 'cancel') {
          // 不显示任何消息，因为用户只是取消了操作
        }
      });
    },
    showWriteOffButton: function showWriteOffButton(row) {
      // 只有当订单状态是2(已下单)，支付状态是1(已支付)，退款状态是0(无退款)时才显示核销按钮
      return row.orderStatus === 2 && row.payStatus === 1 && row.returnStatus === 0;
    },
    formatPrice: function formatPrice(row, column, cellValue) {
      // 格式化价格显示
      return cellValue ? '¥' + parseFloat(cellValue).toFixed(2) : '¥0.00';
    },
    getOrderStatusText: function getOrderStatusText(status) {
      // 订单状态文本映射
      var statusMap = {
        1: '已确认',
        2: '已下单',
        3: '已核销',
        4: '已退单',
        7: '已结单'
      };
      return statusMap[status] || '未知状态';
    },
    getPayStatusText: function getPayStatusText(status) {
      // 支付状态文本映射
      var statusMap = {
        0: '未支付',
        1: '已支付'
      };
      return statusMap[status] || '未知状态';
    },
    getReturnStatusText: function getReturnStatusText(status) {
      // 退款状态文本映射
      var statusMap = {
        0: '无退款',
        1: '已申请',
        2: '已审核',
        4: '已退款'
      };
      return statusMap[status] || '未知状态';
    },
    getInvoiceStatusText: function getInvoiceStatusText(status) {
      // 发票状态文本映射
      var statusMap = {
        0: '未开票',
        1: '已申请',
        2: '已开票',
        3: '已冲红'
      };
      return statusMap[status] || '未知状态';
    },
    handleEdit: function handleEdit(row) {
      console.log('编辑订单:', row);
    },
    formatDate: function formatDate(value) {
      if (!value) return '--';
      // 如果是时间戳格式
      if (typeof value === 'number') {
        var date = new Date(value);
        var year = date.getFullYear();
        var month = String(date.getMonth() + 1).padStart(2, '0');
        var day = String(date.getDate()).padStart(2, '0');
        var hours = String(date.getHours()).padStart(2, '0');
        var minutes = String(date.getMinutes()).padStart(2, '0');
        var seconds = String(date.getSeconds()).padStart(2, '0');
        return "".concat(year, "-").concat(month, "-").concat(day, " ").concat(hours, ":").concat(minutes, ":").concat(seconds);
      }
      // 如果是字符串格式
      if (typeof value === 'string') {
        var _date = new Date(value);
        if (isNaN(_date.getTime())) return value;
        var _year = _date.getFullYear();
        var _month = String(_date.getMonth() + 1).padStart(2, '0');
        var _day = String(_date.getDate()).padStart(2, '0');
        var _hours = String(_date.getHours()).padStart(2, '0');
        var _minutes = String(_date.getMinutes()).padStart(2, '0');
        var _seconds = String(_date.getSeconds()).padStart(2, '0');
        return "".concat(_year, "-").concat(_month, "-").concat(_day, " ").concat(_hours, ":").concat(_minutes, ":").concat(_seconds);
      }
      return value;
    },
    formatBookingDateTime: function formatBookingDateTime(row) {
      // 格式化预约日期时间为 yyyy-MM-dd HH:mm:ss
      return this.formatDate(row.orderDate);
    },
    formatBookingTimePeriod: function formatBookingTimePeriod(row) {
      // 转换时段标识
      if (!row.orderTime) return '';
      var orderTimeLower = row.orderTime.toLowerCase();
      if (orderTimeLower === 'lunch') {
        return '午餐';
      } else if (orderTimeLower === 'dinner') {
        return '晚餐';
      }
      return row.orderTime;
    }
  }
};